import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { getComplimentsData } from '../../../common/api/Practices'
import { PracticeFullScreen } from '../../../common/components/PracticeFullScreen'
import { EVENT_CATEGORY_COMPLIMENTS } from '../../../common/api/UserEvents'
import { ROUTE_ACTIVITIES_COMPLIMENTS_ALL } from '../../../common/helpers/Paths'
import { KEY_PRACTICE_COMPLIMENTS_WP } from 'components/common/api'

export default function ComplimentFullScreen({
  cache,
  setHeaderTitle,
  setReturnPath
}) {
  const { complimentsId } = useParams()

  useEffect(() => {
    // Set header and return path
    setHeaderTitle(null)
    setReturnPath(ROUTE_ACTIVITIES_COMPLIMENTS_ALL)
  }, [complimentsId, cache, setHeaderTitle, setReturnPath])

  return (
    <PracticeFullScreen
      cache={cache}
      practiceId={complimentsId}
      getDataFunction={getComplimentsData}
      eventCategory={EVENT_CATEGORY_COMPLIMENTS}
      practiceType={KEY_PRACTICE_COMPLIMENTS_WP}
    />
  )
}
